
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import vuetify from './plugins/vuetify';
import inputRules from './plugins/inputRules';
import VueTabulator from 'vue-tabulator';
import Tawk from 'vue-tawk';
import CKEditor from '@ckeditor/ckeditor5-vue2';
//npm install --save vue-lodash lodash
import { formatDateForHumans } from './helpers/date-helper'
import { escapeHtml } from './helpers/escapeHtml';
import datePickerHelper from './helpers/date-picker-helper';
/*
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { name: '_' , lodash: lodash })
*/
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(inputRules);
Vue.use(VueTabulator);
Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/616072ea157d100a41ab765d/1fhgc1oou'
})
Vue.filter('formatDateForHumans', formatDateForHumans)
Vue.use( CKEditor );
Vue.use(datePickerHelper);
Vue.prototype.$escapeHtml = escapeHtml;

export default new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')

